import React, { use, useCallback, useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { HiHome } from "react-icons/hi";
import { IoIosArrowForward } from "react-icons/io";
import CircularProgress from "@mui/material/CircularProgress";
import { rxjsStoreProvider } from "../../../context/OrderHistoryRxjsProvider";
import { useNavigate } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CartImage from "../../../assets/CartImage.svg";
import { CgClose } from "react-icons/cg";
import BasketService from "../../../services/basketService";
import { authService } from "../../../services/authService";
import { toast } from "react-hot-toast";
import moment from "moment";
import { BsQuestionLg } from "react-icons/bs";
import OrderRating from "../../Rating/OrderRating";
import { useDispatch, useSelector } from "react-redux";
import { activePlansUpdated, handleCheckoutHybrid, handleReorderFetch } from "../../../store/actions";

function OrderTransactionDetails() {
  const [historyData, setHistoryData] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [toolTipOpen, setToolTipOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orderProducts, setOrderProducts] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const { activePlansCustomerUpdated } = useSelector(
    (state) => state.masterData
  );

  const customerId = authService.getCurrentUserCustomerId();
  const userId = authService.getCurrentUserID();
  const token = authService.getCurrentUserVerificationCode();

  useEffect(() => {
    const subscription$ = rxjsStoreProvider
      .getSingleOrderHistory()
      .subscribe((data) => {
        if (!data?.subscription_ref_no && !data?.salesorder_id) {
          navigate("/home");
        }
        setHistoryData(data);
      });

    return () => {
      if (historyData?.subscription_ref_no || historyData?.salesorder_id) {
        subscription$.unsubscribe();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activePlansCustomerUpdated?.subscription_details?.length && historyData) {
      const filteredOrderProducts = activePlansCustomerUpdated?.subscription_details?.filter((detail) => detail?.subscription_ref_no === historyData?.subscription_ref_no);

      setOrderProducts(filteredOrderProducts);
    }
  }, [activePlansCustomerUpdated?.subscription_details, historyData]);

  const handleReordering = useCallback(async () => {
    try {
      if (historyData?.subscription_ref_no) {
        const id = historyData?.subscription_ref_no;
        dispatch(handleReorderFetch(id)).then((res) => {
          setOrderDetails(res?.payload);

        }).catch((err) => err)
      }
    } catch (err) {
      return err;
    }
  }, [historyData?.subscription_ref_no, dispatch])

  useEffect(() => {
    if (historyData?.subscription_ref_no) {
      handleReordering();
    }
  }, [historyData, handleReordering])

  const buildPlanItemsXML = (cartItems, giftRef) => {
    return cartItems.map((item) => `
    <a>
      <sku>${item?.item_sku}</sku>
      <price>${item?.rate}</price>
      <quantity>${+item?.quantity}</quantity>
      <billing_cycles>${item?.recuring_cycle}</billing_cycles>
      <recuring_infinity>${item?.recuring_cycle}</recuring_infinity>
      <recipient_refno>${giftRef}</recipient_refno>
    </a>
  `);
  };

  function removeSpacesAndNewlines(xml) {
    return xml
      .replace(/\s{2,}/g, '')     // collapse multiple spaces
      .replace(/>\s+</g, '><')    // remove newlines and spaces between tags
      .trim();
  }

  async function confirmRepeatOrder() {
    setOpen(false);
    if (authService.isLogin()) {

      const toastId = toast.loading("reordering...");

      if (historyData?.subscription_ref_no && orderDetails?.length) {
        let cartItemsXML = [];
        const payload = {
          customer_id: customerId,
          customer_pin: "",
          discount_amount: 0,
          coupon_code: "",
          item_info: "",
          c_code: 1001,
          user_id: userId,
          user_token: token,
          applicaton_id: 2,
          option: 7,
        };

        const giftRef = historyData?.gift_recipient_ref_no ? historyData?.gift_recipient_ref_no : 0;

        cartItemsXML = buildPlanItemsXML(orderDetails, giftRef);

        const allItems = [...cartItemsXML].filter(Boolean);
        const xmlStructure = `<root>${allItems.join('')}</root>`;
        const formattedItems = removeSpacesAndNewlines(xmlStructure);

        const finalPayload = {
          ...payload,
          item_info: formattedItems,
        };

        const res = await dispatch(handleCheckoutHybrid(finalPayload)).unwrap();

        if (res?.status === 403) {
          return toast.error(res?.message, { id: toastId });
        }

        if (!res?.Result) {
          return toast.error("Subscriptions could not be created...", { id: toastId });
        }

        toast.success(res?.Message_Text, { id: toastId })

        return dispatch(activePlansUpdated(customerId)).unwrap().then(() => navigate("/home"));
      }
    } else {
      navigate("/login");
      toast.error("You session has expired, please login!");
    }
  }

  function onPressRepeatOrder(orderData) {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="md:flex md:flex-row">
        <div className="flex-1 bg-primary_color">
          {/* Confirm Alert */}
          <div>
            <Dialog
              className="h-full pb-16"
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <div className="h-hug w-full rounded-md border-gray-300 bg-gray-100 shadow shadow-gray-400">
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <div className="flex items-center justify-end">
                      <button
                        onClick={handleClose}
                        className="rounded-full p-2 active:bg-gray-200"
                      >
                        <CgClose className="h-5 w-5 text-gravel-500" />
                      </button>
                    </div>
                    <div className="flex justify-center">
                      <div className="">
                        <img
                          src={CartImage}
                          className="h-24 w-28 sm:h-32 sm:w-36"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="cursor mt-4 flex justify-center text-base font-semibold xsm:text-lg ">
                      <div className=" font-bold text-gray-800">
                        Confirm Re-order
                      </div>
                    </div>
                    <div className="mt-2 text-center text-xs">
                      <div className="text-gray-500">
                        Please confirm that you would like to re-order the
                        details of your your last order.
                      </div>
                    </div>
                    <div className="mt-5 flex flex-col-reverse pb-4 text-center tracking-wider sm:flex-row sm:items-center sm:justify-between">
                      <div
                        onClick={handleClose}
                        className="mt-4 !cursor-pointer rounded-md border-[1px] border-olivine-500 py-2 text-sm font-semibold text-olivine-500 transition duration-300 hover:ring-1 hover:ring-olivine-500 sm:mt-0 sm:px-8"
                      >
                        No, thank you
                      </div>
                      <div className="">
                        <div
                          onClick={confirmRepeatOrder}
                          className="!cursor-pointer rounded-md border-[1px] border-olivine-500 py-2 text-sm font-semibold text-olivine-500 opacity-100 transition duration-300 hover:opacity-80 hover:ring-1 hover:ring-olivine-500 sm:px-8"
                        >
                          Yes, Re-order
                        </div>
                      </div>
                    </div>
                  </DialogContentText>
                </DialogContent>
              </div>
            </Dialog>
          </div>

          {/*  SUBSCRIPTION ITEMS */}

          <div className="w-full px-3 pb-3 pt-4 xsm:px-4 sm:px-8 md:px-10 lg:px-16">
            <div className="flex items-center space-x-3 text-xs font-semibold text-gray-500">
              <div className="flex  items-center space-x-1">
                <div onClick={() => navigate("/")}>
                  <HiHome className="cursor h-4 w-4" />
                </div>
                <div>
                  <IoIosArrowForward className="h-[11px] w-[11px]" />
                </div>
              </div>
              <div
                onClick={() => navigate("/basket/create-basket")}
                className="flex cursor-pointer items-center space-x-1"
              >
                <div>Custom basket</div>
                <div>
                  <IoIosArrowForward className="h-[11px] w-[11px]" />
                </div>
              </div>
              <div
                onClick={() => navigate("/basket/order-history")}
                className="flex cursor-pointer items-center space-x-1"
              >
                <div>Order History</div>
                <div>
                  <IoIosArrowForward className="h-[11px] w-[11px]" />
                </div>
              </div>
              <div className="flex cursor-pointer items-center space-x-1 text-olivine-500">
                <div>Order details </div>
                <div>
                  <IoIosArrowForward className="h-[11px] w-[11px]" />
                </div>
              </div>
            </div>
            {historyData?.subscription_ref_no && (
              <div className="mt-6 flex items-center justify-center text-xs sm:text-sm">
                <div className="w-full max-w-xl space-y-4 pb-16">
                  <div className="mb-12 mt-8 flex items-center space-x-4">
                    <div className="rounded-full  p-1 hover:bg-gray-200">
                      <BiArrowBack
                        onClick={() => navigate(-1)}
                        className="h-6 w-6 cursor-pointer text-gray-600"
                      />
                    </div>
                    <div className="text-lg font-bold text-gravel-600 sm:text-2xl">
                      Order Details
                    </div>
                  </div>
                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="flex w-[130px] items-center space-x-1 whitespace-nowrap font-semibold md:w-48">
                      <div>Transaction Date:</div>
                      {/* <div
                        onClick={() => setToolTipOpen(true)}
                        className="rounded-full bg-olivine-500 p-[3px] text-white"
                      >
                        <BsQuestionLg className="h-2 w-2 cursor-pointer" />
                      </div> */}
                    </div>
                    <div>
                      {historyData?.activated_at
                        ? moment(new Date(historyData?.activated_at)).format(
                          "DD-MM-YYYY"
                        )
                        : moment(new Date(historyData?.activated_at)).format(
                          "DD-MM-YYYY"
                        )}
                    </div>
                  </div>
                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="flex w-[130px] items-center space-x-1 font-semibold md:w-48">
                      <div>Order ID:</div>
                      {/* <div
                        onClick={() => setToolTipOpen(true)}
                        className="rounded-full bg-olivine-500 p-[3px] text-white"
                      >
                        <BsQuestionLg className="h-2 w-2 cursor-pointer" />
                      </div> */}
                    </div>
                    <div className="">{historyData?.subscription_ref_no} </div>
                  </div>
                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Product Name:
                    </div>
                    <div>{orderProducts && orderProducts?.length && orderProducts[0]?.product_feature_name} </div>
                  </div>
                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Plan:
                    </div>
                    <div>
                      {orderProducts && orderProducts?.length
                        ? orderProducts[0]?.item_name
                        : historyData?.subscription_name}
                    </div>
                  </div>

                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Activated Date:
                    </div>
                    <div>
                      {orderProducts && orderProducts?.length && orderProducts[0]?.subscription_activated_date ? (
                        moment(new Date(orderProducts[0]?.subscription_activated_date)).format(
                          "DD-MM-YYYY"
                        )
                      ) : (
                        moment(new Date(historyData?.activated_at)).format(
                          "DD-MM-YYYY"
                        )
                      )}

                    </div>
                  </div>
                  {historyData && historyData?.recuring_cycle > 1 && (
                    <div className="flex xsm:px-2 sm:px-6">
                      <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                        Start Date:
                      </div>
                      <div>
                        {orderProducts && orderProducts?.length && orderProducts[0]?.subscription_created_date ? (
                          moment(new Date(orderProducts[0]?.subscription_created_date)).format(
                            "DD-MM-YYYY"
                          )
                        ) : (
                          moment(new Date(historyData?.activated_at)).format(
                            "DD-MM-YYYY"
                          )
                        )}
                      </div>
                    </div>
                  )}

                  {historyData && historyData?.recuring_cycle > 1 && (
                    <div className="flex xsm:px-2 sm:px-6">
                      <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                        End Date:
                      </div>
                      <div>
                        {orderProducts && orderProducts?.length && orderProducts[0]?.subscription_end_date ? (
                          moment(new Date(orderProducts[0]?.subscription_end_date)).format(
                            "DD-MM-YYYY"
                          )
                        ) : (
                          null
                        )}
                      </div>
                    </div>
                  )}

                  {historyData && historyData?.recuring_cycle > 1 && (
                    <div className="flex xsm:px-2 sm:px-6">
                      <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                        Next Billing:
                      </div>
                      <div>
                        {/* {historyData?.next_billing_at
                        ? moment(new Date(historyData?.next_billing_at)).format(
                            "DD-MM-YYYY"
                          )
                        : ""} */}

                        {orderProducts && orderProducts?.length && orderProducts[0]?.next_bill_on ? (
                          moment(new Date(orderProducts[0]?.next_bill_on)).format(
                            "DD-MM-YYYY"
                          )
                        ) : ""
                        }
                      </div>
                    </div>
                  )}

                  {historyData && historyData?.recuring_cycle > 1 && (
                    <div className="flex xsm:px-2 sm:px-6">
                      <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                        Interval:
                      </div>
                      <div>Monthly</div>
                    </div>
                  )}



                  <div className="space-y-1 xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Order Details
                    </div>

                    {/*  start  */}
                    {orderProducts && orderProducts?.length && orderProducts?.map((plan) => {
                      return (
                        <div className="flex text-[10px] text-gray-600 xsm:text-[11px] sm:text-[12px]">
                          <div className="whitespace-nowrap' w-[130px] space-x-1 pl-2 md:w-48">
                            <span className="">{plan?.item_name} </span>
                            <span className="">x</span>
                            <span className="">{plan?.quantity}</span>
                          </div>
                          <div className="">
                            <span className=" font-semibold">
                              <CurrencyFormat
                                value={Number.parseFloat(plan?.total)?.toFixed(
                                  2
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                                // prefix={historyData?.currency_symbol}
                                prefix={"₦"}
                              />
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {historyData?.gift_id === 1 && (
                    <div className="flex flex-col">
                      <div className="w-[130px] whitespace-nowrap font-semibold md:w-48 flex xsm:px-2 sm:px-4 mb-4">
                        Gift Receipient Details
                      </div>
                      <div className="flex xsm:px-2 sm:px-6">
                        <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                          Name:
                        </div>
                        <div>
                          {historyData && historyData?.gift_person_name && (
                            historyData?.gift_person_name
                          )
                          }
                        </div>
                      </div>

                      <div className="flex xsm:px-2 sm:px-6 my-2">
                        <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                          Phone Number:
                        </div>
                        <div>
                          {historyData && historyData?.gift_person_mobile_number && (
                            historyData?.gift_person_mobile_number
                          )
                          }
                        </div>
                      </div>

                      <div className="flex xsm:px-2 sm:px-6">
                        <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                          Address:
                        </div>
                        <div>
                          {historyData && historyData?.gift_person_full_address && (
                            historyData?.gift_person_full_address
                          )
                          }
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="flex text-lg xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Total:
                    </div>
                    <div>
                      <CurrencyFormat
                        className={"font-bold "}
                        value={Number.parseFloat(historyData?.total_subscription_amount)?.toFixed(
                          2
                        )}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </div>
                  </div>

                  <div className="">
                    <button
                      disabled={loading}
                      onClick={() => onPressRepeatOrder(historyData)}
                      className="mt-4 w-full rounded-md border-[1px] border-olivine-500 bg-[#F0F7E1] py-2 text-base opacity-75 transition duration-300 hover:opacity-100 hover:ring-[1px] hover:ring-olivine-500"
                    >
                      <div className="space-x-2 text-center font-semibold text-olivine-500">
                        {loading ? (
                          <CircularProgress color="success" size="1.16rem" />
                        ) : (
                          <span>Repeat Order</span>
                        )}
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* SALES ORDER ITEM */}
            {historyData?.salesorder_id && (
              <div className="col-span-3 mt-6 flex items-center justify-center text-xs sm:text-sm">
                <div className="w-full max-w-xl space-y-4 pb-16">
                  <div className="mb-12 mt-8 flex items-center space-x-4">
                    <div className="rounded-full  p-1 hover:bg-gray-200">
                      <BiArrowBack
                        onClick={() => navigate(-1)}
                        className="h-6 w-6 cursor-pointer text-gray-600"
                      />
                    </div>
                    <div className="text-lg font-bold text-gravel-600 sm:text-2xl">
                      Order Details
                    </div>
                  </div>
                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="flex w-[130px] items-center space-x-1 whitespace-nowrap font-semibold md:w-48">
                      <div>Transaction Date:</div>
                      <div
                        onClick={() => setToolTipOpen(true)}
                        className="rounded-full bg-olivine-500 p-[3px] text-white"
                      >
                        <BsQuestionLg className="h-2 w-2 cursor-pointer" />
                      </div>
                    </div>
                    <div>
                      {moment(new Date(historyData?.created_time)).format(
                        "DD-MM-YYYY"
                      )}
                    </div>
                  </div>
                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="flex w-[130px] items-center space-x-1 font-semibold md:w-48">
                      <div>Order ID:</div>
                      <div
                        onClick={() => setToolTipOpen(true)}
                        className="rounded-full bg-olivine-500 p-[3px] text-white"
                      >
                        <BsQuestionLg className="h-2 w-2 cursor-pointer" />
                      </div>
                    </div>
                    <div className="">{historyData?.salesorder_id} </div>
                  </div>
                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Product Name:
                    </div>
                    <div>{historyData?.salesorder_number} </div>
                  </div>
                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Plan:
                    </div>
                    <div> Custom Basket </div>
                  </div>

                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Activated Date:
                    </div>
                    <div>
                      {moment(new Date(historyData?.activated_at)).format(
                        "DD-MM-YYYY"
                      )}
                    </div>
                  </div>
                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Start Date:
                    </div>
                    <div>
                      {moment(new Date(historyData?.start_date)).format(
                        "DD-MM-YYYY"
                      )}
                    </div>
                  </div>

                  <div className="flex xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Shipping:
                    </div>
                    <div>{historyData?.shipping_charge} </div>
                  </div>
                  <div className="space-y-1 xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Order Details
                    </div>

                    {/* start */}
                    {historyData?._item_list?.map((plan, index) => {
                      return (
                        <div
                          key={index}
                          className="flex text-[10px] text-gray-600 xsm:text-[11px] sm:text-[12px]"
                        >
                          <div className="whitespace-nowrap' w-[130px] space-x-1 pl-2 md:w-48">
                            <span className="">{plan?.name} </span>
                            <span className="">x</span>
                            <span className="">{plan?.quantity}</span>
                          </div>
                          <div className="">
                            <span className="font-semibold">
                              <CurrencyFormat
                                value={Number.parseFloat(plan?.rate)?.toFixed(
                                  2
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={historyData?.currency_symbol}
                              />
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* end */}

                  <div className="flex text-lg xsm:px-2 sm:px-6">
                    <div className="w-[130px] whitespace-nowrap font-semibold md:w-48">
                      Total:
                    </div>
                    <div>
                      <CurrencyFormat
                        className={"font-bold "}
                        value={Number.parseFloat(
                          historyData?.total_amount
                        )?.toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={historyData?.currency_symbol}
                      />
                    </div>
                  </div>
                  <div className="">
                    <button
                      onClick={() => onPressRepeatOrder(historyData)}
                      className="mt-4 w-full rounded-md border-[1px] border-olivine-500 bg-[#F0F7E1] py-2 text-base opacity-75 transition duration-300 hover:opacity-100 hover:ring-[1px] hover:ring-olivine-500"
                    >
                      <div className="space-x-2 text-center font-semibold text-olivine-500">
                        {loading ? (
                          <CircularProgress color="success" size="1.16rem" />
                        ) : (
                          <span>Repeat Order</span>
                        )}
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="w-full md:max-w-[400px]">
          <OrderRating historyData={historyData} orderProducts={orderProducts} />
        </div>
      </div>
    </>
  );
}

export default OrderTransactionDetails;
